import { render, staticRenderFns } from "./NewsModal.vue?vue&type=template&id=6e4dd3e2&scoped=true"
import script from "./NewsModal.vue?vue&type=script&lang=js"
export * from "./NewsModal.vue?vue&type=script&lang=js"
import style0 from "./NewsModal.vue?vue&type=style&index=0&id=6e4dd3e2&prod&lang=scss&scoped=true"
import style1 from "./NewsModal.vue?vue&type=style&index=1&id=6e4dd3e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4dd3e2",
  null
  
)

export default component.exports